<template>
  <div>
    <b-card title="Ajuizamentos" id="painelAjuizamento">
      <b-row class="destaque2" id="destaquesAjuizamento">
        <b-col md="4" class="d-flex flex-column justify-content-center my-2">
          <div>
            <div class="mx-auto passo-p passo_inativo">
              <img
                src="@/assets/img/icones/cda-sefa.png"
                alt="Quantidade de CDAs disponibilizadas pela SEFA no mês de referência"
                v-b-tooltip.hover
                title="Total de CDAs direcionadas para Ajuizamento"
              />
            </div>
            <template v-if="resultado.qtdeGeralAjuizamento != null">
              <div class="destaque1-p">CDA´s: {{resultado.qtdeGeralAjuizamento}}</div>
            </template>
            <template v-else>
              <div class="destaque1-p">Carregando..</div>
            </template>
          </div>
        </b-col>
        <b-col md="4" class="d-flex flex-column justify-content-center my-2">
          <div>
            <div class="mx-auto passo-p passo_inativo">
              <img
                src="@/assets/img/icones/livro_off.png"
                :alt="'Previsão de Processos - Atualizado em ' + dataAtualizacaoProcessos"
                v-b-tooltip.hover
                :title="'Previsão de Processos - Atualizado em ' + dataAtualizacaoProcessos"
              />
            </div>
            <template v-if="resultado.qtdeGeralPrevisoes != null">
              <div class="destaque1-p">Processos: {{resultado.qtdeGeralPrevisoes}}</div>
            </template>
            <template v-else>
              <div class="destaque1-p">Carregando..</div>
            </template>
          </div>
        </b-col>
        <b-col md="4" class="d-flex flex-column justify-content-center my-2">
          <div>
            <div class="mx-auto passo-p passo_inativo">
              <img
                src="@/assets/img/icones/movimentacao.png"
                alt="Quantidade de CDAs disponibilizadas pela SEFA no mês de referência"
                v-b-tooltip.hover
                title="Valor das CDAs direcionadas para Ajuizamento"
              />
            </div>
            <template v-if="resultado.valorGeralAjuizamento != null">
              <div class="destaque1-p">Valor Total: R$ {{resultado.valorGeralAjuizamento | currency}}</div>
            </template>
             <template v-else>
              <div class="destaque1-p">Carregando..</div>
            </template>
          </div>
        </b-col>
      </b-row>

      <b-row class="justify-content-between" id="primeiraLinhaAjuizamento">
        <Item
          titulo="CDA's Disponíveis"
          icone="images/icones/cda-sefa.png"
          link="/ajuizamento/exibir-divida-disponivel"
          tooltip="CDAs disponíveis para seleção do Ajuizamento"
          :quantidade="resultado.qtdeDisponiveisAjuizamento"
          :valor="resultado.valorDisponiveisAjuizamento"
          :exibirProcesso="true"
          :processos="resultado.qtdePrevisaoProcessosDisponiveisAjuizamento"
        />
        <b-col lg="1">
          <div class="seta">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </div>
        </b-col>
        <Item
          titulo="Montagem de Processos"
          icone="images/icones/livro_off.png"
          link="/ajuizamento/exibir-processos-montados"
          tooltip="CDAs agrupadas em processos judiciais pendentes de ajuizamento"
          :quantidade="resultado.qtdeMontadasAjuizamento"
          :valor="resultado.valorMontadasAjuizamento"
          :exibirProcesso="true"
          :processos="resultado.qtdePrevisaoProcessosMontadasAjuizamento"
        />
        <b-col lg="1">
          <div class="seta">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </div>
        </b-col>
        <Item
          titulo="Ajuizadas"
          icone="images/icones/balanca_off.png"
          link="/ajuizamento/exibir-ajuizadas"
          tooltip="CDAs ajuizadas"
          :quantidade="resultado.qtdeAjuizadas"
          :valor="resultado.valorAjuizadas"
          :exibirProcesso="true"
          :processos="resultado.qtdePrevisaoProcessosAjuizadas"
        />
      </b-row>
      <b-row class="justify-content-between" id="segundaLinhaAjuizamento">
        <Item
          titulo="Exceções"
          icone="images/icones/deferido_off.png"
          link="/ajuizamento/exibir-excecoes-ajuizamento"
          tooltip="CDAs retiradas em razão da lista de exceção"
          :quantidade="resultado.qtdeExcecoesAjuizamento"
          :valor="resultado.valorExcecoesAjuizamento"
        />
        <!-- <b-col lg="1"><div class="seta"><i class="fa fa-arrow-right" aria-hidden="true"></i></div></b-col> -->
        <Item
          titulo="Erros"
          icone="images/icones/erro_off.png"
          link="/ajuizamento/exibir-erros-ajuizamento"
          tooltip="CDAs que apresentaram erro durante o processamento do Ajuizamento"
          :quantidade="resultado.qtdeErrosAjuizamento"
          :valor="resultado.valorErrosAjuizamento"
        />
        <!-- <b-col lg="1"><div class="seta"><i class="fa fa-arrow-right" aria-hidden="true"></i></div></b-col> -->
        <Item
          titulo="Excluídas"
          icone="images/icones/excluidas.png"
          link="/ajuizamento/exibir-excluidas-ajuizamento"
          tooltip="CDAs excluídas por informação de pagamento, parcelamento ou retificações na SEFA"
          :quantidade="resultado.qtdeExcluidasAjuizamento"
          :valor="resultado.valorExcluidasAjuizamento"
        />
      </b-row>
    </b-card>

    <b-card>
      <b-row class="diferenca-totais" id="diferencaTotaisAjuizamento">
        <b-col md="3" class="d-flex flex-column justify-content-center my-2">
          <template v-if="resultado.qtdeGeralAjuizamento != null">
            <div>CDA´s: {{somaQuantidadeAjuizamento}} <span style="color:red">
              <span v-if="diferencaQuantidadeAjuizamento > 0">
                &#8800; {{diferencaQuantidadeAjuizamento}}</span>
              </span>
            </div>
          </template>
          <template v-else>
            <div>Carregando..</div>
          </template>
        </b-col>
        <b-col md="3" class="d-flex flex-column justify-content-center my-2">
          <template v-if="resultado.qtdeGeralAjuizamento != null">
            <div>Processo: {{somaProcessosAjuizamento}} <span style="color:red">
              <span v-if="diferencaProcessosAjuizamento > 0">
                &#8800; {{diferencaProcessosAjuizamento}}</span>
            </span>
            </div>
          </template>
          <template v-else>
            <div>Carregando..</div>
          </template>
        </b-col>
        <b-col md="6" class="d-flex flex-column justify-content-center my-2">
          <template v-if="resultado.valorGeralAjuizamento != null">
            <div>Valor Total: R$ {{somaValoresAjuizamento | currency}}
              <span style="color:red"><span v-if="diferencaValoresAjuizamento > 0">
                &#8800; R$ {{diferencaValoresAjuizamento | currency}}</span>
              </span>
            </div>
          </template>
          <template v-else>
            <div>Carregando..</div>
          </template>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>


<script>
import Item from "./CompItem";
import axios from 'axios'

export default {
  components: {
    Item
  },
  data() {
    return {
      ano: null,
      mes: null,
      somaQuantidadeAjuizamento: null,
      somaProcessosAjuizamento: null,
      somaValoresAjuizamento: null,
      diferencaQuantidadeAjuizamento: null,
      diferencaProcessosAjuizamento: null,
      diferencaValoresAjuizamento: null,
      dataAtualizacaoProcessos: 'Carregando...',
      resultado: []
    }
  },
  methods: {
    async consultarAjuizamento(ano, mes) {
          this.alterarTamanhoPaineis();

          this.ano = ano;
          this.mes = mes;
          this.resultado = [];
          this.somaQuantidadeAjuizamento = 0;
          this.somaProcessosAjuizamento = 0;
          this.somaValoresAjuizamento = 0;
          this.diferencaQuantidadeAjuizamento = 0;
          this.diferencaProcessosAjuizamento = 0;
          this.diferencaValoresAjuizamento = 0;
          const urlApi = process.env.VUE_APP_ROOT_API
          axios.post(`${urlApi}/v1/monitoramentoDividas/consultarAjuizamento/${this.ano}/${this.mes}`, {
              headers: {
                  'Content-Type': 'application/json',
              }
          })
          .then(response => {
              this.resultado = response.data;
              this.dataAtualizacaoProcessos = this.resultado.dataAtualizacaoPrevisoes;
              this.calcularDiferencas();
              this.alterarTamanhoPaineis();
          }).finally(() => {
               this.$emit('atualizarDadosGerais')
          })
      },
      obterValorGeral(){
        return this.resultado.valorGeralAjuizamento;
      },
      obterQtdeGeral(){
        return this.resultado.qtdeGeralAjuizamento;
      },
      calcularDiferencas(){
        this.calcularDiferencaCdas();
        this.calcularDiferencaProcessos();
        this.calcularDiferencaValorTotal();
      },
      calcularDiferencaCdas(){
        if(this.resultado.qtdeGeralAjuizamento != null){
          this.somaQuantidadeAjuizamento = this.resultado.qtdeDisponiveisAjuizamento + this.resultado.qtdeMontadasAjuizamento +
              this.resultado.qtdeAjuizadas + this.resultado.qtdeExcecoesAjuizamento + this.resultado.qtdeErrosAjuizamento +
              this.resultado.qtdeExcluidasAjuizamento;
          this.somaQuantidadeAjuizamento = Math.round((this.somaQuantidadeAjuizamento + Number.EPSILON) * 100) / 100;
          this.diferencaQuantidadeAjuizamento = this.resultado.qtdeGeralAjuizamento - this.somaQuantidadeAjuizamento;
          if(this.diferencaQuantidadeAjuizamento < 0) {
              this.diferencaQuantidadeAjuizamento = this.diferencaQuantidadeAjuizamento * -1;
          }
        }
      },
      calcularDiferencaProcessos(){
        if(this.resultado.qtdeGeralPrevisoes != null){
          this.somaProcessosAjuizamento = this.resultado.qtdePrevisaoProcessosDisponiveisAjuizamento +
              this.resultado.qtdePrevisaoProcessosMontadasAjuizamento +
              this.resultado.qtdePrevisaoProcessosAjuizadas;
          this.somaProcessosAjuizamento = Math.round((this.somaProcessosAjuizamento + Number.EPSILON) * 100) / 100;
          this.diferencaProcessosAjuizamento = this.resultado.qtdeGeralPrevisoes - this.somaProcessosAjuizamento;
          if(this.diferencaProcessosAjuizamento < 0) {
              this.diferencaProcessosAjuizamento = this.diferencaProcessosAjuizamento * -1;
          }
        }
      },
      calcularDiferencaValorTotal(){
        if(this.resultado.valorGeralAjuizamento != null){
          this.somaValoresAjuizamento = this.resultado.valorDisponiveisAjuizamento + this.resultado.valorMontadasAjuizamento +
              this.resultado.valorAjuizadas + this.resultado.valorExcecoesAjuizamento + this.resultado.valorErrosAjuizamento +
              this.resultado.valorExcluidasAjuizamento;
          this.somaValoresAjuizamento = Math.round((this.somaValoresAjuizamento + Number.EPSILON) * 100) / 100;
          this.diferencaValoresAjuizamento = this.resultado.valorGeralAjuizamento - this.somaValoresAjuizamento;
          if(this.diferencaValoresAjuizamento < 0) {
              this.diferencaValoresAjuizamento = this.diferencaValoresAjuizamento * -1;
          }
        }
      },
      alterarTamanhoPaineis(){
          this.ajustaTamanhoItem("primeiraLinhaProtestos", "primeiraLinhaAjuizamento");
          this.ajustaTamanhoItem("segundaLinhaProtestos", "segundaLinhaAjuizamento");
      },
      ajustaTamanhoItem(idPrimeiro, idSegundo) {
          let tamanhoPrimeiro = document.getElementById(idPrimeiro).offsetHeight;
          let tamanhoSegundo = document.getElementById(idSegundo).offsetHeight;
          if(tamanhoPrimeiro > tamanhoSegundo) {
              document.getElementById(idSegundo).setAttribute("style","height:"+ tamanhoPrimeiro + 'px');
          } else {
              document.getElementById(idPrimeiro).setAttribute("style","height:"+ tamanhoSegundo + 'px');
          }
      }
  },
};
</script>

<style scoped>
.card-title {
  text-align: center;
  font-size: 1.5rem;
}
</style>
